import {
  SUCCESS_CREATE_PHARMACY,
  SUCCESS_DELETE_PHARMACY,
  SUCCESS_UPDATE_PHARMACY,
  SET_HEADER_FILTER_PHARMACIES,
} from "Actions/PharmacyAction";
import {
  START_GET_LOGIN_USER,
  SUCCESS_GET_LOGIN_USER,
  ERROR_GET_LOGIN_USER,
  START_GET_PHARMACY_CONFIG,
  SUCCESS_GET_PHARMACY_CONFIG,
  ERROR_GET_PHARMACY_CONFIG,
  START_GET_REFRESHTOKEN,
  SUCCESS_GET_REFRESHTOKEN,
  ERROR_GET_REFRESHTOKEN,
  START_UPDATE_FIRST_LOGIN_TOUR,
  SUCCESS_UPDATE_FIRST_LOGIN_TOUR,
  ERROR_UPDATE_FIRST_LOGIN_TOUR,
} from "Actions/UserAction";
import { setLocalStorage } from "utils/generalUtils";

const initialState = {
  loginUserDetail: {
    loading: false,
    daat: {},
    error: "",
  },
  pharmacyConfigData: {
    loading: false,
    data: {},
    error: "",
  },
  refreshTokenDetail: {
    loading: false,
    daat: {},
    error: "",
  },
  firstLoginDetails: {
    loading: false,
    data: {},
    error: "",
  },
  headerSelectedPharmaciesFilter: [],
};

export const UserReducer = (state = initialState, action) => {
  switch (action.type) {
    case START_GET_LOGIN_USER: {
      return {
        ...state,
        loginUserDetail: {
          loading: true,
          data: {},
          error: "",
        },
      };
    }
    case SUCCESS_GET_LOGIN_USER: {
      return {
        ...state,
        loginUserDetail: {
          loading: false,
          data: action.payload,
          error: "",
        },
      };
    }
    case ERROR_GET_LOGIN_USER: {
      return {
        ...state,
        loginUserDetail: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_GET_REFRESHTOKEN: {
      return {
        ...state,
        refreshTokenDetail: {
          loading: true,
          data: {},
          error: "",
        },
      };
    }
    case SUCCESS_GET_REFRESHTOKEN: {
      return {
        ...state,
        refreshTokenDetail: {
          loading: false,
          data: action.payload,
          error: "",
        },
      };
    }
    case ERROR_GET_REFRESHTOKEN: {
      return {
        ...state,
        refreshTokenDetail: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }

    case START_GET_PHARMACY_CONFIG: {
      let oldList = state?.pharmacyConfigData?.data;
      return {
        ...state,
        pharmacyConfigData: {
          loading: action?.payload?.offset > 0 ? false : true,
          data: action?.payload?.offset > 0 ? oldList : {},
          error: "",
        },
      };
    }
    case SUCCESS_GET_PHARMACY_CONFIG: {
      let oldList = state?.pharmacyConfigData?.data;
      if (oldList?.list?.length > 0) {
        oldList.list = [...oldList?.list, ...action?.payload?.data?.list];
      } else {
        oldList = action?.payload?.data;
      }
      return {
        ...state,
        pharmacyConfigData: {
          loading: false,
          data: oldList,
          error: "",
        },
      };
    }
    case ERROR_GET_PHARMACY_CONFIG: {
      return {
        ...state,
        pharmacyConfigData: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case SUCCESS_CREATE_PHARMACY: {
      let oldList = state?.pharmacyConfigData?.data;
      oldList.list = [
        { id: action?.payload?.data?.id, name: action?.payload?.data?.name },
        ...oldList?.list,
      ];
      oldList.filterd_record = oldList?.filterd_record + 1;
      return {
        ...state,
        pharmacyConfigData: {
          loading: false,
          data: oldList,
          error: "",
        },
      };
    }
    case SUCCESS_UPDATE_PHARMACY: {
      let oldList = state?.pharmacyConfigData?.data;
      oldList.list = oldList?.list?.map((item) => {
        if (item?.id == action?.id) {
          return {
            ...item,
            name: action?.payload?.data?.name,
          };
        } else {
          return item;
        }
      });
      return {
        ...state,
        pharmacyConfigData: {
          loading: false,
          data: oldList,
          error: "",
        },
      };
    }
    case SUCCESS_DELETE_PHARMACY: {
      let oldList = state?.pharmacyConfigData?.data;
      oldList.list = oldList?.list?.filter((item) => item?.id != action?.id);
      oldList.filterd_record = oldList?.filterd_record - 1;
      return {
        ...state,
        pharmacyConfigData: {
          loading: false,
          data: oldList,
          error: "",
        },
      };
    }
    case SET_HEADER_FILTER_PHARMACIES: {
      const pharmacyObj = action.payload;
      //store in local storage [pharmacyObj]
      // setLocalStorage("Pharmacies", JSON.stringify([pharmacyObj?.id]));
      // setLocalStorage("pharmacy",pharmacyObj);
      return {
        ...state,
        headerSelectedPharmaciesFilter:
          pharmacyObj.id === "all" ? ["all"] : [pharmacyObj],
      };
    }
    case START_UPDATE_FIRST_LOGIN_TOUR: {
      console.log("checking start");

      return {
        ...state,
        firstLoginDetails: {
          loading: true,
          data: {},
          error: "",
        },
      };
    }
    case SUCCESS_UPDATE_FIRST_LOGIN_TOUR: {
      console.log("checking success");

      return {
        ...state,
        firstLoginDetails: {
          loading: false,
          data: action.payload,
          error: "",
        },
      };
    }
    case ERROR_UPDATE_FIRST_LOGIN_TOUR: {
      console.log("checking error");

      return {
        ...state,
        firstLoginDetails: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    default: {
      return state || initialState;
    }
  }
};
